import { observable } from "mobx";
import { Type } from "class-transformer";
import DistributorPaymentRequestResponse from "./distributorPaymentRequestResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorRefundCandidateSummaryResponse {
  @observable
  @Type(() => DistributorPaymentRequestResponse)
  distributorPaymentRequest!: DistributorPaymentRequestResponse;

  @observable
  openRefundCandidateItemsCount!: number;
}
